module.exports = __webpack_public_path__ + "img/1764125056097-KERIPIK SINGKONG MAMA 3N.jpg.122a0fa1.webp";